const config = [
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '基本信息',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '异议答复',
        },
    },
    {
        component: 'ZlmNormalDetail',
        options: {
            data: {},
        },
    },
    {
        component: 'ZlmTitle',
        options: {
            size: 'medium',
            text: '审核记录',
        },
    },
    {
        component: 'ZlmTabDetail',
        options: {
            title: '记录',
            data: [],
        },
    },
]

const { getApproveStatusName } = require('../approveStatus')

const mixin = {
    data() {
        return {
            config: JSON.parse(JSON.stringify(config)),
        }
    },
    methods: {
        getData() {
            this.$request.post(`/transformToAfter/app/open/bid/detail`, {
                yiYiGuid: this.$route.query.id,
            }, { showLoading: true }).then((res) => {
                this.getApproveList(this.$route.query.id)
                const answerStatusText = {
                    0: '未答复',
                    1: '已答复',
                    2: '已确认',
                }
                const spStatusText = {
                    1: '未签收',
                    2: '已签收',
                    3: '已答复',
                }
                this.config[1].options.data = {
                    '标段名称': res.data.bdName,
                    '标段编号': res.data.bdBH,
                    '发起单位': res.data.startUnit,
                    '联系人': res.data.linkman,
                    '联系电话': res.data.linkPhone,
                    '异议标段': res.data.bdBH,
                    '异议发起时间': this.$util.timeFormatter(res.data.objectionStartTime),
                    '异议截止时间': this.$util.timeFormatter(res.data.objectionEndTime),
                    '异议标题': res.data.objectionTitle,
                    '答复状态': answerStatusText[res.data.answerStatus],
                    '异议内容': res.data.objectionContent,
                    '项目异议书': '',
                    '其他附件': '',
                }

                this.config[3].options.data = {
                    '异议答复标题': res.data.objectionAnswerTitle,
                    '流程状态': spStatusText[res.data.spStatus],
                    '异议答复内容': res.data.objectionAnswerContent,
                    '异议答复函': '',
                }
            })
        },
        getApproveList(guid) {
            this.$request.post(`/transformToAfter/app/approve/record/getApproveRecordByBusKey`, {
                businessKey: `TBYiYi:${guid}`,
            }).then((res) => {
                if (res.data.length) {
                    this.config[5].options.data = res.data.map((t) => ({
                        '提交人': t.commitUserName,
                        '提交时间': this.$util.timeFormatter(t.commitTime),
                        '审批人': t.approveUserName,
                        '审批结果': getApproveStatusName(t.statusMsg),
                        '审批时间': this.$util.timeFormatter(t.approveTime),
                        '审批意见': '',
                        '审批附件': '',
                    }))
                }
            })
        },
    },
}

module.exports = {
    config,
    mixin,
}
